import React from 'react';

export const SuccessfulIcon: React.FC = () => (
  <svg
    width="136"
    height="138"
    viewBox="0 0 136 138"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M68 8.87891C35.1422 8.87891 8.5 35.717 8.5 68.8164C8.5 101.916 35.1422 128.754 68 128.754C100.858 128.754 127.5 101.916 127.5 68.8164C127.5 35.717 100.858 8.87891 68 8.87891ZM68 118.586C40.7203 118.586 18.5938 96.2967 18.5938 68.8164C18.5938 41.3361 40.7203 19.0469 68 19.0469C95.2797 19.0469 117.406 41.3361 117.406 68.8164C117.406 96.2967 95.2797 118.586 68 118.586Z"
      fill="#EAEAEA"
    />
    <path
      d="M68 19.0469C40.7203 19.0469 18.5938 41.3361 18.5938 68.8164C18.5938 96.2967 40.7203 118.586 68 118.586C95.2797 118.586 117.406 96.2967 117.406 68.8164C117.406 41.3361 95.2797 19.0469 68 19.0469ZM93.6859 49.2431L65.7156 88.3095C65.3247 88.8591 64.8093 89.307 64.2123 89.616C63.6152 89.9249 62.9537 90.0861 62.2824 90.0861C61.6112 90.0861 60.9496 89.9249 60.3526 89.616C59.7555 89.307 59.2402 88.8591 58.8492 88.3095L42.3008 65.1907C41.7961 64.4816 42.3008 63.4916 43.1641 63.4916H49.393C50.7609 63.4916 52.0359 64.1605 52.8328 65.271L62.2891 78.4894L83.1672 49.3233C83.9641 48.1995 85.2523 47.5439 86.607 47.5439H92.8359C93.6992 47.5439 94.2039 48.534 93.6859 49.2431Z"
      fill="#F8F8F8"
    />
    <path
      d="M92.8363 47.543H86.6073C85.2527 47.543 83.9644 48.1985 83.1675 49.3224L62.2893 78.4884L52.8331 65.27C52.0362 64.1596 50.7612 63.4906 49.3932 63.4906H43.1643C42.301 63.4906 41.7963 64.4807 42.301 65.1897L58.8495 88.3085C59.2404 88.8582 59.7558 89.306 60.3528 89.615C60.9499 89.924 61.6115 90.0851 62.2827 90.0851C62.9539 90.0851 63.6155 89.924 64.2125 89.615C64.8096 89.306 65.325 88.8582 65.7159 88.3085L93.6863 49.2421C94.2042 48.533 93.6995 47.543 92.8363 47.543Z"
      fill="#BCBCBC"
    />
  </svg>
);
